import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'app-vendor-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './vendor-management.component.html',
  styleUrls: ['./vendor-management.component.css']
})
export class VendorManagementComponent implements OnInit {
  suppliers: any[] = [];
  managers: any[] = [];
  
  // Supplier form
  showSupplierForm = false;
  supplierForm = {
    name: '',
    email: '',
    password: '',
    companyName: '',
    phone: ''
  };
  
  // Manager form
  showManagerForm = false;
  managerForm = {
    name: '',
    email: '',
    password: '',
    phone: ''
  };
  
  loading = false;
  error = '';
  success = '';

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.loadSuppliers();
    this.loadManagers();
  }

  loadSuppliers() {
    this.apiService.getSuppliers().subscribe({
      next: (data) => {
        this.suppliers = data;
      },
      error: (err) => {
        console.error('Error loading suppliers:', err);
      }
    });
  }

  loadManagers() {
    this.apiService.getProcurementManagers().subscribe({
      next: (data) => {
        this.managers = data;
      },
      error: (err) => {
        console.error('Error loading managers:', err);
      }
    });
  }

  showAddSupplierForm() {
    this.showSupplierForm = true;
    this.showManagerForm = false;
    this.resetSupplierForm();
  }

  showAddManagerForm() {
    this.showManagerForm = true;
    this.showSupplierForm = false;
    this.resetManagerForm();
  }

  resetSupplierForm() {
    this.supplierForm = {
      name: '',
      email: '',
      password: '',
      companyName: '',
      phone: ''
    };
    this.error = '';
    this.success = '';
  }

  resetManagerForm() {
    this.managerForm = {
      name: '',
      email: '',
      password: '',
      phone: ''
    };
    this.error = '';
    this.success = '';
  }

  createSupplier() {
    if (!this.supplierForm.name || !this.supplierForm.email || !this.supplierForm.password) {
      this.error = 'Please fill in all required fields';
      return;
    }

    if (this.supplierForm.password.length < 6) {
      this.error = 'Password must be at least 6 characters long';
      return;
    }

    this.loading = true;
    this.error = '';
    this.success = '';

    const userData = {
      ...this.supplierForm,
      userType: 'Supplier'
    };

    this.apiService.createUser(userData).subscribe({
      next: () => {
        this.success = 'Supplier created successfully!';
        this.loading = false;
        this.loadSuppliers();
        setTimeout(() => {
          this.showSupplierForm = false;
          this.resetSupplierForm();
        }, 2000);
      },
      error: (err) => {
        this.error = err.error?.message || 'Error creating supplier';
        this.loading = false;
      }
    });
  }

  createManager() {
    if (!this.managerForm.name || !this.managerForm.email || !this.managerForm.password) {
      this.error = 'Please fill in all required fields';
      return;
    }

    if (this.managerForm.password.length < 6) {
      this.error = 'Password must be at least 6 characters long';
      return;
    }

    this.loading = true;
    this.error = '';
    this.success = '';

    const userData = {
      ...this.managerForm,
      userType: 'ProcurementManager'
    };

    this.apiService.createUser(userData).subscribe({
      next: () => {
        this.success = 'Procurement Manager created successfully!';
        this.loading = false;
        this.loadManagers();
        setTimeout(() => {
          this.showManagerForm = false;
          this.resetManagerForm();
        }, 2000);
      },
      error: (err) => {
        this.error = err.error?.message || 'Error creating procurement manager';
        this.loading = false;
      }
    });
  }

  cancelSupplierForm() {
    this.showSupplierForm = false;
    this.resetSupplierForm();
  }

  cancelManagerForm() {
    this.showManagerForm = false;
    this.resetManagerForm();
  }
}










